/**
 * Ensures only one Clareza drawer is open at a time:
 * menu, search, cart, filters, sort-by.
 */
(function () {
  const closeMenu = () => {
    const menuDrawer = document.getElementById('menu-drawer');
    const menuToggle = document.getElementById('menu-toggle');
    const menuOverlay = document.getElementById('MenuOverlay');
    if (!menuDrawer) return;
    menuDrawer.classList.remove('open', 'submenu-open', 'submenu-active');
    menuToggle?.classList.remove('open');
    if (menuOverlay) menuOverlay.style.display = 'none';
    document.querySelector('.menu-column-left')?.classList.remove('hidden');
    document.querySelectorAll('.menu-sub').forEach((menu) => menu.classList.remove('active'));
    document.querySelectorAll('.menu-link').forEach((link) => link.classList.remove('active'));
  };

  const closeSearch = () => {
    document.getElementById('search-drawer')?.classList.remove('open');
  };

  const closeCart = () => {
    const cart = document.querySelector('cart-drawer');
    if (cart && typeof cart.close === 'function') cart.close();
    else cart?.classList.remove('active', 'animate');
  };

  const closeFilters = () => {
    document.getElementById('filters-panel')?.classList.remove('active', 'open');
    document.getElementById('sortby-panel')?.classList.remove('active', 'open');
    const overlay = document.getElementById('FiltersOverlay');
    if (overlay) overlay.style.display = 'none';
  };

  const unlockBody = () => {
    document.body.style.overflow = '';
    document.body.classList.remove('overflow-hidden');
  };

  window.ClarezaDrawers = {
    closeAll(except) {
      if (except !== 'menu') closeMenu();
      if (except !== 'search') closeSearch();
      if (except !== 'cart') closeCart();
      if (except !== 'filters') closeFilters();
      if (!except) unlockBody();
    },
    open(name) {
      this.closeAll(name);
      if (name === 'search' || name === 'menu' || name === 'filters') {
        document.body.style.overflow = 'hidden';
      }
      if (name === 'cart') {
        document.body.classList.add('overflow-hidden');
      }
    },
  };
})();
